import { filterDate_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import { filterDropdown_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import { filterPreset_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterPreset_template";
import { filterSimple_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import { multipleSelector_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import { pagination_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { resultsInfo_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { filterTag_template } from "./filterTag_template";
import { filterUser_template } from "./filterUser_template";

declare var ko: any;

export class videosList_template extends vnTemplate {
    protected categoryFilter: multipleSelector_template;
    protected contentTypeFilter: multipleSelector_template;
    protected filterDate: filterDate_template;
    protected filterUploadSource: filterDropdown_template;
    protected filterPreset: filterPreset_template;
    protected filterProducer: filterUser_template;
    protected filterSimple: filterSimple_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;
    protected tagFilter: filterTag_template;

    protected getTemplateHtml(): string {
        return /*html*/`
            <div id="list-references">
                <div class="sub-header filter-preset w-justify ">
                    ${this.filterPreset.getHtmlBuild()}
                </div>

                <div class="sub-header w-justify">
                    <div class="w-left">
                        ${this.filterProducer.getHtmlBuild()}
                        ${this.tagFilter.getHtmlBuild()}
                        ${this.categoryFilter.getHtmlBuild()}
                        ${this.contentTypeFilter.getHtmlBuild()}
                        <div>
                            <label class="form-label">Upload Source</label>
                            ${this.filterUploadSource.getHtmlBuild()}
                        </div>
                        ${this.filterDate.getHtmlBuild()}
                    </div>
                </div>
            </div>

            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                   <div id="selected-producers"></div>
                   <div id="selected-tags"></div>
                   <div id="selected-categories"></div>
                   <div id="selected-content_types"></div>
                </div>
            </div>

            <div class="list-header w-justify" >
                <div class="w-left" data-bind="if: isAddButtonShown">
                    <button data-bind="click: onClickAdd" class="btn secondary icon i-video-2" type="button">Create Video</button>
                </div>
                <div class="w-center">
                    ${this.filterSimple.getHtmlBuild()}
                </div>
                <div class="w-right">
                    ${this.pagination.getHtmlBuild()}
                </div>
            </div>

            <div class="w-list-results w-video-list list-article" id="list-results">
                <table class="list-results">
                    ${this.resultInfos.getHtmlBuild()}
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">ID</span></th>
                            <th><span>Thumbnail</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'title') }, css: { 'list-sort-desc': orderByAndDirection()=='title_DESC', 'list-sort-asc': orderByAndDirection()=='title_ASC' }">Title</span></th>
                            <th><span>Subtitles</span></th>
                            <th><span>URL</span></th>
                            <th><span>Video Article</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'producer') }, css: { 'list-sort-desc': orderByAndDirection()=='producer_DESC', 'list-sort-asc': orderByAndDirection()=='producer_ASC' }">Producer</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Uploaded On</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='dateUpdated_ASC' }">Updated On</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: videos">
                        <tr  class="cursor">
                            <td data-bind="event: { click: $parent.onClickView }">
                                <a data-bind="attr: { href :   '/brand/' + $parent.idBrand() + '/videos/view/' + $data.id }">
                                    <span data-bind="text: id"></span>
                                </a>
                            </td>
                            <td class="has-image" data-bind="event: { click: $parent.onClickView }">
                                <a data-bind="attr: { href :   '/brand/' + $parent.idBrand() + '/videos/view/' + $data.id }">
                                    <img class="thumbnail" data-bind="attr: { src: thumbnail }"  alt="" />
                                </a>
                            </td>
                            <td data-bind="event: { click: $parent.onClickView }">
                                <a data-bind = "attr: { href :   '/brand/' + $parent.idBrand() + '/videos/view/' + $data.id }">
                                   <span data-bind="text: title"></span>                                  
                                </a>                            
                            </td>
                            <td data-bind="event: { click: $parent.onClickView }">
                                <a data-bind="attr: { href :   '/brand/' + $parent.idBrand() + '/videos/view/' + $data.id }">
                                   <span data-bind="text: subtitleStatus"></span>
                                </a>
                            </td>
                            <td>
                                <div class="flex" style="justify-content: space-between;">
                                    
                                    <a class="btn icon border only-icon i-video-2" target="_blank" rel="noopener noreferrer" data-bind="attr: { href: url }"></a>
                                </div>
                            </td>
                            <td>
                                <div class="flex" style="justify-content: space-between; gap: 0.5rem">
                                    <a class="btn icon" type="button" 
                                            data-bind="css: idArticle ? 'border only-icon i-link' : 'border only-icon i-article',
                                            event: { click: $parent.onClickGenerateVideoArticle }
                                            ">
                                        </a>
                                        <span style="white-space: nowrap" data-bind="text: idArticle ? articleTitle : 'Generate Video Article'"></span>
                                </div>
                            </td>
                            <td data-bind="event: { click: $parent.onClickView }">
                                <a data-bind="attr: { href :   '/brand/' + $parent.idBrand() + '/videos/view/' + $data.id }">
                                    <span data-bind="text: producer"></span>
                                </a>
                            </td>
                            <td data-bind="event: { click: $parent.onClickView }">
                                <a data-bind="attr: { href :   '/brand/' + $parent.idBrand() + '/videos/view/' + $data.id }">
                                    <span data-bind="text: dateCreated"></span>
                                </a>
                            </td>
                            <td data-bind="event: { click: $parent.onClickView }">
                                <a data-bind="attr: { href :   '/brand/' + $parent.idBrand() + '/videos/view/' + $data.id }">
                                    <span data-bind="text: dateUpdated"></span>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            `;
    }

    protected getTemplateName(): string {
        return "videosList-template";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected initPartial(): void {
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

        this.filterProducer = new filterUser_template("producerFilter", this.getTemplateViewModel(), this.caller);
        this.filterProducer.asMultipleSelectionMode();
        this.filterProducer.setTagContainerId("selected-producers");
        this.filterProducer.setTagContainerCaption("Selected producers:");
        this.filterProducer.setPlaceholderText("Producer");
        this.filterProducer.setUniqueIdentifier("producerId");

        this.filterDate = new filterDate_template("dateFilter", this.getTemplateViewModel(), this.caller);
        this.filterDate.getTemplateViewModel().startDate(null);
        this.filterDate.getTemplateViewModel().endDate(null);
        this.filterDate.toggleClearButton(true);
        this.filterDate.setLabel("Date Range");

        this.filterUploadSource = new filterDropdown_template("uploadSourceFilter", this.getTemplateViewModel(), this.caller);
        this.filterUploadSource.setLabel("Upload Source");
        this.filterUploadSource.setOptions([{ id: "Network", name: "Network" }]);

        this.filterPreset = new filterPreset_template("filterPreset", this.getTemplateViewModel(), this.caller);
        this.filterPreset.getTemplateViewModel().searchPresetType("videos");

        this.filterSimple = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);

        this.tagFilter = new filterTag_template("tagFilter", this.getTemplateViewModel(), this.caller);
        this.tagFilter.asMultipleSelectionMode();

        this.categoryFilter = new multipleSelector_template("categoryFilter", this.getTemplateViewModel(), this.caller);
        this.categoryFilter.setLabel("category");
        this.categoryFilter.setFilterContainerClass("margin-neg");
        this.categoryFilter.setTagContainerId("selected-categories");
        this.categoryFilter.setTagContainerCaption("Selected categories:");

        this.contentTypeFilter = new multipleSelector_template(
            "contentTypeFilter",
            this.getTemplateViewModel(),
            this.caller,
        );
        this.contentTypeFilter.setLabel("content type");
        this.contentTypeFilter.setFilterContainerClass("margin-neg");
        this.contentTypeFilter.setTagContainerId("selected-content_types");
        this.contentTypeFilter.setTagContainerCaption("Selected content types:");
    }

    protected buildViewModel(): any {
        let self = this;
        return {
            idBrand: ko.observable(null),
            isAddButtonShown: ko.observable(true),
            orderBy: ko.observable("dateCreated"),
            orderByAndDirection: ko.observable("dateCreated_DESC"),
            orderByDirection: ko.observable("DESC"),
            videos: ko.observableArray([]),
            permissions: ko.observableArray(this.initPermissions(["article_list_self", "article_list_brand"])),
            onClickAdd: () => {
                self.onClickAdd();
            },
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            onClickView: (data, event) => {
                self.onClickView(data, event);
            },
            onClickGenerateVideoArticle : function (data) {
                self.generateVideoArticle(data);
            }
        };
    }

    public getViewModelForRequest() {
        return {
            filters: {
                dateFilterType: this.getTemplateViewModel().dateFilter.selectedFilter(),
                startDate: this.getTemplateViewModel().dateFilter.startDate(),
                startDateRange: this.getTemplateViewModel().dateFilter.fromRange(),
                endDate: this.getTemplateViewModel().dateFilter.endDate(),
                endDateRange: this.getTemplateViewModel().dateFilter.toRange(),
                keywords: this.getTemplateViewModel().filter.filterKeyword,
                producers: this.filterProducer.getUsersForRequest(),
                tags: this.tagFilter.getTagsForRequest(),
                categories: this.categoryFilter.getSelectedItems(),
                contentTypes: this.contentTypeFilter.getSelectedItems(),
                uploadSource: this.getTemplateViewModel().uploadSourceFilter.selectedOption,
            },
            orderBy: this.getTemplateViewModel().orderBy,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            searchPresetName: this.getTemplateViewModel().filterPreset.searchPresetName(),
            searchPresetType: this.getTemplateViewModel().filterPreset.searchPresetType(),
            videoPagination: this.getTemplateViewModel().pagination,
        };
    }

    public setViewModelFromRequest(urlParams) {
        if (urlParams != null) {
            if (urlParams.dateFilterType) {
                this.filterDate.getTemplateViewModel().selectedFilter(urlParams.dateFilterType);
            }
            if (urlParams.startDateRange || urlParams.endDateRange) {
                this.filterDate.setRange(urlParams.startDateRange, urlParams.endDateRange);
            }
            if (urlParams.startDate || urlParams.endDate) {
                this.setDateFilters(urlParams.startDate, urlParams.endDate);
            }

            let keywordString = urlParams.keywords;
            if (urlParams.keywords) {
                keywordString = urlParams.keywords.replaceAll("+", " ");
            }
            this.filterSimple.getTemplateViewModel().filterKeyword(keywordString);

            if (urlParams.producers) {
                this.filterProducer.setSelectedUsersFromRequestParams(urlParams.producers);
            } else {
                this.filterProducer.resetTagContainer();
            }

            if (urlParams.tags) {
                this.tagFilter.setSelectedTagsFromRequestParams(urlParams.tags);
            } else {
                this.tagFilter.resetTagContainer();
            }

            this.setFilterSelectedItems(this.categoryFilter, urlParams.categories);
            this.setFilterSelectedItems(this.contentTypeFilter, urlParams.contentTypes);

            if (urlParams.uploadSource) {
                this.getTemplateViewModel().uploadSourceFilter.selectedOption(urlParams.uploadSource);
            }
        }
    }

    public addCreatedPresetToList(response) {
        this.filterPreset.addCreatedPresetToList(response);
    }

    public buildDatePickerCalendar() {
        this.filterDate.buildCalendar();
    }

    public onClickAdd() {
        this.caller.addVideo();
    }

    public onClickReorder(value, data, event) {
        data.orderBy(value);
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            data.orderByDirection("DESC");
        }
        data.orderByAndDirection(value + "_" + data.orderByDirection());
        this.caller.videosListReorder();
    }

    public onClickView(data, event) {
        if (event.target.id.indexOf("site-view") == -1) {
            this.caller.viewVideo(data.id);
        }
    }

    public setAddButtonShown(isAddButtonShown: boolean) {
        this.getTemplateViewModel().isAddButtonShown(isAddButtonShown);
    }

    private setDateFilters(startDate, endDate) {
        if (startDate) {
            startDate = new Date(startDate.replace(/-/g, "/"));
        }
        if (endDate) {
            endDate = new Date(endDate.replace(/-/g, "/"));
        }
        this.filterDate.setDateRange(startDate, endDate);
    }

    public setProducerFilter(producers) {
        this.filterProducer.setUsers(producers);
    }

    public setResultInfo(nbResults, nbPages, execTime) {
        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setSearchPresets(presets) {
        this.filterPreset.setSearchPresets(presets);
    }

    public setVideos(videos: Array<{}>): void {
        this.getTemplateViewModel().videos(videos);
    }

    public setIdBrand(idBrand) {
        this.getTemplateViewModel().idBrand(idBrand);
    }

    private setTagPreset(idTag: number, tag: string): void {
        this.tagFilter.getTemplateViewModel().idTag(idTag);
        this.tagFilter.getTemplateViewModel().tag(tag);
        this.tagFilter.toggleCloseButton();
    }

    protected setTagFilter(tags) {
        this.tagFilter.setTags(tags);
    }

    public setCategoryFilter(items) {
        this.categoryFilter.setItems(items);
    }

    public setContentTypeFilter(items) {
        this.contentTypeFilter.setItems(items);
    }

    public setUploadSourceFilter(items, selectedUploadSource?) {
        this.filterUploadSource.setOptions(items);
        this.getTemplateViewModel().uploadSourceFilter.setSelectedOption(selectedUploadSource);
    }

    public setFilterSelectedItems(objFilter, urlParams) {
        let splitString = [];

        // Multi select filters.
        if (Array.isArray(urlParams)) {
            urlParams = urlParams.toString();
        }
        if (urlParams) {
            if (typeof urlParams == "string") {
                splitString = urlParams.split(",");
            } else {
                splitString = [urlParams];
            }
            let arrayParam = [];
            let idTagArray = [];
            splitString.forEach((id) => {
                if (!isNaN(Number(id))) {
                    id = Number(id);
                } else {
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({ id: id });
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        } else {
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }

    protected generateVideoArticle(data) {
        
        this.caller.generateVideoArticle(data,data.idArticle);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/videosList_template.ts